/** Temporary debug CSV helpers (FOUNDER dashboard calculation audit). */

export function csvEscape(v: string | number | boolean | null | undefined): string {
  if (v == null) return '';
  const s = typeof v === 'boolean' ? (v ? 'true' : 'false') : String(v);
  if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

export function toCsv(
  headers: string[],
  rows: Array<Array<string | number | boolean | null | undefined>>,
): string {
  const head = headers.map(csvEscape).join(',');
  const body = rows.map((r) => r.map(csvEscape).join(','));
  return [head, ...body].join('\n') + '\n';
}

export function downloadCsv(filename: string, csv: string): void {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export const CALC_HEADERS = [
  'block',
  'metric',
  'value',
  'prior',
  'formula',
  'source',
  'window_from',
  'window_to',
  'connection_id',
  'notes',
] as const;
